(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzampas-anchornav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nav = document.querySelector('[data-tz-anchornav]');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('.tz-anchornav__link'));
    var header = document.querySelector('.tzah');

    // position:sticky klebt nur innerhalb des Eltern-Blocks. Da jede Shopify-Sektion
    // in einem eigenen (kurzen) Wrapper steckt, verschieben wir die Nav direkt hinter
    // den Hub-Header (Eltern = <body>), damit sie über die ganze Seite kleben kann.
    if (header && header.parentNode) {
      header.parentNode.insertBefore(nav, header.nextSibling);
    }

    function offsetTop() {
      var h = header ? header.offsetHeight : 0;
      return h + nav.offsetHeight + 12;
    }
    function reposition() {
      var h = header ? header.offsetHeight : 0;
      nav.style.top = h + 'px';
      document.documentElement.style.setProperty('--tz-anchor-offset', offsetTop() + 'px');
    }
    reposition();
    window.addEventListener('resize', reposition);
    window.addEventListener('load', reposition);

    // Template-Sektionen haben die ID shopify-section-template--<id>__<key>.
    // Darum per Suffix "__<key>" auflösen (Fallback: exakte ID).
    var map = links.map(function (l) {
      var key = l.getAttribute('data-tz-anchor') || '';
      var t = key ? (document.querySelector('[id$="__' + key + '"]') || document.getElementById(key)) : null;
      if (t) l.setAttribute('href', '#' + t.id);
      return { link: l, target: t };
    });

    function setActive(target) {
      map.forEach(function (m) { m.link.classList.toggle('is-active', m.target === target); });
    }

    map.forEach(function (m) {
      if (!m.target) return;
      m.link.addEventListener('click', function (e) {
        e.preventDefault();
        var y = m.target.getBoundingClientRect().top + window.pageYOffset - offsetTop() + 2;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
        setActive(m.target);
        if (history.replaceState) history.replaceState(null, '', '#' + m.target.id);
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          for (var i = 0; i < map.length; i++) { if (map[i].target === e.target) { setActive(e.target); break; } }
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      map.forEach(function (m) { if (m.target) io.observe(m.target); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzampas-colorpalette"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.tz-pal__swatch[data-tz-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var hex = btn.getAttribute('data-tz-copy');
        var hint = btn.querySelector('.tz-pal__copyhint');
        var done = function () {
          btn.classList.add('is-copied');
          if (hint) hint.textContent = 'Kopiert ✓';
          setTimeout(function () { btn.classList.remove('is-copied'); if (hint) hint.textContent = 'Kopieren'; }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(hex).then(done).catch(function () {});
        } else {
          var t = document.createElement('textarea'); t.value = hex; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzampas-coupons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-tz-coup-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dlg = root.querySelector('#' + btn.getAttribute('data-tz-coup-open'));
          if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
          else if (dlg) dlg.setAttribute('open', '');
        });
      });
      root.querySelectorAll('[data-tz-coup-dialog]').forEach(function (dlg) {
        var closer = dlg.querySelector('[data-tz-coup-close]');
        if (closer) closer.addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) {
          if (e.target === dlg) dlg.close();
        });
      });
      root.querySelectorAll('[data-tz-coup-copy]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var code = btn.getAttribute('data-tz-coup-copy') || '';
          var done = function () {
            btn.classList.add('is-done');
            var l = btn.querySelector('.tz-coup__copy-label');
            var d = btn.querySelector('.tz-coup__copy-done');
            if (l) l.hidden = true;
            if (d) d.hidden = false;
            setTimeout(function () {
              btn.classList.remove('is-done');
              if (l) l.hidden = false;
              if (d) d.hidden = true;
            }, 2000);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done).catch(done);
          } else {
            var ta = document.createElement('textarea');
            ta.value = code; document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); } catch (e) {}
            document.body.removeChild(ta); done();
          }
        });
      });
    }
    document.querySelectorAll('.tz-coup').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzampas-experts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initExp(root) {
      if (root.dataset.tzExpInit) return;
      root.dataset.tzExpInit = '1';
      var track = root.querySelector('.tz-exp__track');
      var prev = root.querySelector('.tz-exp__nav--prev');
      var next = root.querySelector('.tz-exp__nav--next');
      if (!track) return;

      function step() {
        var card = track.querySelector('.tz-exp__card');
        var w = card ? card.getBoundingClientRect().width : 300;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 24;
        return w + gap;
      }
      function updateNav() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.hidden = track.scrollLeft <= 1;
        if (next) next.hidden = track.scrollLeft >= maxScroll;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();

      // Maus-Drag-to-scroll (Desktop) - auf Touch uebernimmt natives Swipe
      var isDown = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        isDown = true; moved = false;
        startX = e.clientX; startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        updateNav();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      // Klick nach echtem Drag unterdruecken (verhindert versehentliches Folgen von Links)
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    }
    function initAll() { document.querySelectorAll('[data-tz-exp]').forEach(initExp); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzampas-video"] && !Shopify.designMode) return;
  try {
    
  // Setzt das Seitenverhältnis des Players auf die ECHTEN Video-Maße, sobald bekannt.
  // Global für jede Instanz der Sektion; respektiert preload="none" (feuert erst bei Play/Metadaten).
  (function () {
    function applyRatio(video) {
      var w = video.videoWidth, h = video.videoHeight;
      if (!w || !h) return;
      var player = video.closest('[data-tz-vid-player]');
      if (player) player.style.setProperty('--tz-vid-ratio', w + ' / ' + h);
    }
    function init(root) {
      (root || document).querySelectorAll('.tz-vid__video').forEach(function (video) {
        if (video.dataset.tzRatioBound) return;
        video.dataset.tzRatioBound = '1';
        if (video.readyState >= 1) applyRatio(video); // Metadaten schon da
        video.addEventListener('loadedmetadata', function () { applyRatio(video); });
      });
    }

    // Autoplay-Steuerung: nur GIF-artige Autoplay-Clips (.tz-vid--autoplay video).
    // Das bloße autoplay-Attribut startet nicht zuverlässig beim Reinscrollen;
    // ein IntersectionObserver garantiert Bewegung im Viewport + Offscreen-Pause (Performance).
    // Der Testimonial-/Nicht-Autoplay-Pfad wird NICHT angefasst → spielt nie automatisch.
    var tzVidIO = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              video.muted = true; // Autoplay-Policy: nur muted erlaubt
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.25, rootMargin: '200px 0px' })
      : null;

    function initAutoplay(root) {
      (root || document).querySelectorAll('.tz-vid--autoplay video').forEach(function (video) {
        if (video.dataset.tzAutoplayBound) return;
        video.dataset.tzAutoplayBound = '1';
        video.muted = true;
        if (tzVidIO) {
          tzVidIO.observe(video);
        } else {
          // Fallback (uralt-Browser ohne IntersectionObserver): einfach abspielen.
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      });
    }

    function run(root) { init(root); initAutoplay(root); }

    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', function () { run(); });
    // Theme-Editor: neu gerenderte Sektion erneut binden
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
